import PropTypes from "prop-types"

const priceLinePropTypes = PropTypes.shape({
	net: PropTypes.number.isRequired,
	vat: PropTypes.number.isRequired,
})

/**
 * PropTypes for PriceLinesTable component
 *
 * @property {Object|null} [priceLines] - Price lines of the session (opc, energy, chargingFee, tar, egme, iec), null when it was not priced by the price list
 * @property {string} [currency] - Currency code, EUR by default
 */
export const priceLinesTablePropTypes = {
	priceLines: PropTypes.shape({
		opc: priceLinePropTypes,
		energy: priceLinePropTypes,
		chargingFee: priceLinePropTypes,
		tar: priceLinePropTypes,
		egme: priceLinePropTypes,
		iec: priceLinePropTypes,
	}),
	currency: PropTypes.string,
}
